export default __webpack_public_path__ + "static/media/0273.78893c56.jpg";